import { render } from "./BalTable.vue?vue&type=template&id=28b70144"
import script from "./BalTable.vue?vue&type=script&lang=ts"
export * from "./BalTable.vue?vue&type=script&lang=ts"

import "./BalTable.vue?vue&type=style&index=0&id=28b70144&lang=css"
script.render = render

export default script